import client from "./client";

export type FeedbackStatus = "open" | "resolved";

export type FeedbackUser = {
  id: string;
  email: string;
  full_name: string;
};

export type FeedbackExcerptMessage = {
  id: string;
  role: string;
  content: string | null;
  sql_generated?: string | null;
  created_at?: string | null;
};

export type FeedbackAttachmentInput = {
  filename: string;
  content_type: string;
  size_bytes: number;
  data: string;
};

export type FeedbackAttachmentMeta = {
  id: string;
  filename: string;
  content_type: string;
  size_bytes: number;
  created_at: string | null;
};

export type FeedbackItem = {
  id: string;
  status: FeedbackStatus;
  comment: string;
  resolution_note: string | null;
  answer_snapshot: string;
  sql_snapshot: string | null;
  previous_user_prompt: string | null;
  conversation_excerpt: FeedbackExcerptMessage[] | null;
  attachments: FeedbackAttachmentMeta[];
  reporter: FeedbackUser | null;
  resolver: FeedbackUser | null;
  conversation_id: string | null;
  message_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  resolved_at: string | null;
};

export type FeedbackListResponse = {
  items: FeedbackItem[];
  open_count: number;
};

export type FeedbackSubmitPayload = {
  messageId: string;
  comment: string;
  attachments?: FeedbackAttachmentInput[];
};

export const feedbackApi = {
  submit: ({ messageId, comment, attachments }: FeedbackSubmitPayload) =>
    client.post<FeedbackItem>("/feedback", {
      message_id: messageId,
      comment,
      attachments: attachments ?? [],
    }),

  listAdmin: (status?: FeedbackStatus) =>
    client.get<FeedbackListResponse>("/admin/feedback", {
      params: status ? { status } : undefined,
    }),

  getAdmin: (id: string) => client.get<FeedbackItem>(`/admin/feedback/${id}`),

  updateAdmin: (
    id: string,
    data: { status?: FeedbackStatus; resolution_note?: string | null },
  ) => client.patch<FeedbackItem>(`/admin/feedback/${id}`, data),

  getAttachmentUrl: (feedbackId: string, attachmentId: string) =>
    client.get<{ url: string }>(
      `/admin/feedback/${feedbackId}/attachments/${attachmentId}`,
    ),
};
